import React from "react";
import { useState } from "react";
import Swal from "sweetalert2";

const Contact = () => {
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  // Step 2: Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await fetch("https://topfaculty.co.in/api/web_lead.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData), // Must be JSON encoded!
      });
  
      const result = await response.json();
      console.log("API Response:", result);
  
      if (result.status === "success") {
        Swal.fire("Success!", result.message, "success");
        setFormData({ name: "", phone: "", email: "" });
      } else {
        Swal.fire("Error!", result.message, "error");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      Swal.fire("Error!", "Network error or invalid response", "error");
    }
  };
  return (
    <>
     <div id="rs-latest-news" className="rs-courses-details ">
        <img
          src="assetsfront/images/contact.jpg"
          alt="Banner Image"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />
        <div className="container">
          <div className="row mt-4">
            <h1
              className="title text-center "
              style={{ fontWeight: "700" }}
            >
              Contact-<span class="info-color">Us </span>
            </h1>
          </div>

          <div className="row">
            <div className="col-md-1"></div>

            <div className="col-md-10">
              <div className="#">
                <div className="container h-100">
                  <div className="row h-100 justify-content-center align-items-center">
                    <form
                      className="col-md-12"
                      method="POST"
                      onSubmit={handleSubmit}
                    >
                      <div className="AppForm shadow-lg">
                        <div className="row">
                          <div className="col-md-6">
                            <div
                              className="align-items-center  p-3 text-white"
                              style={{
                                backgroundImage:
                                  "url('assetsfront/images/form.avif')",
                              }}
                            >
                              {/* <img src="assetsfront/images/stulog.png" style={{ border: "3px solid white",borderRadius: "205px",padding: "1px"}}></img> */}
                              <h2
                                className="text-center"
                                style={{
                                  fontSize: "28px",
                                  color: "white",
                                  fontWeight: "700",
                                }}
                              >
                                Contact <span>Information</span>
                              </h2>
                              <p
                                className=" py-2"
                                style={{
                                  fontSize: "18px",
                                  color: "white",
                                  fontWeight: "700",
                                }}
                              >
                                <i className="  fa fa-home" /> Head office
                                Rohini
                              </p>

                <p><a href="mailto:topfauclty01@gmail.com" class="text-blue-600 hover:underline">topfauclty01@gmail.com</a></p>

                              <p
                                className=""
                                style={{
                                  fontSize: "15px",
                                  color: "white",
                                  fontWeight: "700",
                                }}
                              >
                                <i className=" fa fa-map-marker" /> Address: D-11/156 Sector 8 Rohini, Opp-Pillar No-389, Rohini East Metro Station, Delhi - 110085, India
                              </p>
                              <p
                                className=""
                                style={{
                                  fontSize: "15px",
                                  color: "white",
                                  fontWeight: "700",
                                }}
                              >
                                <i className=" fa fa-phone" /> 9911753333, 011-45623302-08
                              </p>
                              <hr />

                              <p
                                className=" py-2"
                                style={{
                                  fontSize: "18px",
                                  color: "white",
                                  fontWeight: "700",
                                }}
                              >
                                <i className="  fa fa-home" /> Branch Mukherjee
                                Nagar
                              </p>

                              <p
                                className=""
                                style={{
                                  fontSize: "15px",
                                  color: "white",
                                  fontWeight: "700",
                                }}
                              >
                                <i className=" fa fa-map-marker" /> B-17 Opp.
                                Aggarwal Sweets, Mukherjee Nagar,New Delhi-
                                110009
                              </p>
                              <p
                                className=""
                                style={{
                                  fontSize: "15px",
                                  color: "white",
                                  fontWeight: "700",
                                }}
                              >
                                <i className=" fa fa-phone" /> 9911753333,
                                011-45623302-08
                              </p>
                            </div>
                          </div>

                          <div className="col-md-6  p-4 align-items-center ">
                            <div className="AppFormLeft">
                              <h1>How Can We Help You ?</h1>
                              <p>
                                If you have any questions or query regarding
                                programs, suggestions to make, feel free to give
                                us a call or fill out the form below
                              </p>
                              <div className="form-group position-relative mb-4">
                                <input
                                  type="text"
                                  className="form-control "
                                  id="username"
                                  placeholder="Name"
                                  name="name"
                                  value={formData.name}
                                  onChange={handleChange}
                                required/>
                                <i className="fa fa-user-o" />
                              </div>
                              
                              <div className="form-group position-relative mb-4">
                                <input
                                  type="email"
                                  className="form-control "
                                  id="username"
                                  placeholder="Email"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleChange}
                               required />
                                <i className="fa fa-envelope" />
                              </div>
                              <div className="form-group position-relative mb-4">
                                <input
                                  type="number"
                                  className="form-control "
                                  id="username"
                                  placeholder="Phone"
                                  name="phone"
                                  value={formData.phone}
                                  onChange={handleChange}
                                required/>
                                <i className="fa fa-phone" />
                              </div>

                              <button
                                type="submit"
                                className="btn btn-success btn-block shadow border-0 py-2 text-uppercase "
                              >
                                Send Message
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-1"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
